import { getColourFromVar } from 'reporting/components/charts/utils/graph-utils';

export const hexToRgba = (hex: string, opacity: number) => {
    const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const cssVarToHex = (cssVar: string): string => {
    let rawVar = cssVar;

    if (rawVar[0] === '#') {
        return rawVar;
    }

    if (rawVar.startsWith('var(') && rawVar.endsWith(')')) {
        rawVar = rawVar.slice(4).slice(0, -1);
    }

    return getColourFromVar(rawVar);
};
